import React, { useEffect, useState } from "react";

export default function ScrollProgress() {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const scrolled = h.scrollTop;
      const total = h.scrollHeight - h.clientHeight;
      setPct(total > 0 ? (scrolled / total) * 100 : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      aria-hidden
      style={{
        position: "fixed",
        top: 0, left: 0,
        height: 3,
        width: `${pct}%`,
        background: "linear-gradient(90deg,#22d3ee,#6366f1,#a855f7,#ec4899)",
        zIndex: 200,
        transition: "width 0.1s linear",
        boxShadow: "0 0 12px rgba(168,85,247,0.7)",
      }}
    />
  );
}
